var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.control)?_c('div',{staticClass:"box"},[_c('img',{staticClass:"advertImg",attrs:{"src":_vm.imgurl,"alt":""}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }